import * as api from '../../api/api-reasignar-responsable';
import { 
    GET_CONFIG_FORM28,
    GET_COMBO_ZONAS,
    GET_DATOS_GRILLA_RESPONSABLE,
    GET_DATOS_GESTION_CASO,
    POST_ASIGNAR_RESPONSABLE,
    GET_COMBO_TIPO_NOTIFICA
    
} from '../types';

export const configuracionFormAction28 = (query) => ({
    type: GET_CONFIG_FORM28,
    payload: api.getConfiguracionForm28(query)
});
export const obtenerComboZonas = (query) => ({
    type: GET_COMBO_ZONAS,
    payload: api.getComboZonas(query)
});
export const obtenerDatosGrilla = (query) => ({
    type: GET_DATOS_GRILLA_RESPONSABLE,
    payload: api.getDatosGrilla(query)
});
export const obtenerDatosGestionCaso = (query) => ({
    type: GET_DATOS_GESTION_CASO,
    payload: api.getDatosGestion(query)
});
export const enviarAsignacion = (resp) => ({
    type: POST_ASIGNAR_RESPONSABLE,
    payload: api.postReasignarResponsable(resp)
});
export const obtenerTipoNotifica = (query) => ({
    type: GET_COMBO_TIPO_NOTIFICA,
    payload: api.getTipoNotificaSiniestro(query)
});